import { NgModule, SecurityContext } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LandingGeneralRoutingModule } from './landing-general-routing.module';
import { LandingGeneralComponent } from './landing-general.component';
import { TranslateModule } from '@ngx-translate/core';
import { LandingContentComponent } from './landing-content/landing-content.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MarkdownModule } from 'ngx-markdown';


@NgModule({
  declarations: [LandingGeneralComponent, LandingContentComponent],
  imports: [
    CommonModule,
    LandingGeneralRoutingModule,
    MarkdownModule.forRoot({
      // Disable rich text mardown sanitization
      sanitize: SecurityContext.NONE
    }),
    TranslateModule.forChild({
      extend: true,
    }),
    FlexLayoutModule,
  ],
  exports: [
    LandingContentComponent
  ]
})
export class LandingGeneralModule { }
